export type ReviewRunHistoryRecord = {
  status: string;
  created_at: string;
  updated_at?: string;
  provider_finished_at?: string;
  completed_at?: string;
};

const terminalReviewRunStatuses = new Set(["completed", "failed", "aborted"]);

function finishedAt(run: ReviewRunHistoryRecord) {
  for (const value of [run.completed_at, run.updated_at, run.provider_finished_at, run.created_at]) {
    const timestamp = value ? Date.parse(value) : Number.NaN;
    if (Number.isFinite(timestamp)) return timestamp;
  }
  return 0;
}

export function recentTerminalReviewRuns<T extends ReviewRunHistoryRecord>(
  runs: T[],
  limit = 20,
) {
  return runs
    .filter((run) => terminalReviewRunStatuses.has(run.status))
    .sort((left, right) => finishedAt(right) - finishedAt(left))
    .slice(0, Math.max(0, limit));
}
